import React, { Fragment } from "react";
import ProfilePic from "components/General/ProfilePic";
import TextTheme from "components/General/Text/TextTheme";
import "components/Feeds/Feeds.css";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

/*Copied and modified from https://material-ui.com/components/tooltips/#interactive*/
const DateTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "#1a3867",
    border: "1px solid #bebebe",
    fontSize: 12,
  },
}))(Tooltip);

class NewsfeedComment extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  /* Like date format from UserStartedProject
   * Time comes in format "2021-02-04T14:26:41.571831Z" and leaves "Feb 04, 2021 9:29:41 AM"
   * depending on time zone.
   * if the date is "Just now" do not format it.
   */
  formatDate(date) {
    if (date === "Just now") return date;

    /*Copied from UserStartedProject*/
    let event = new Date(date);
    const formattedDate = Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    }).format(event);
    const time = event.toLocaleTimeString("en-US");

    return formattedDate + " " + time;
  }

  render() {
    return (
      <Fragment>
        <div className="comment_column">
          <ProfilePic
            profilePic={this.props.profilePic}
            className="comment_profile_pic"
          />
          <div className="comment_message">
            <TextTheme
              message={this.props.username}
              className="text_semi_bold text_small"
            />
            <DateTooltip
              title={"Sent: " + this.formatDate(this.props.datePosted)}
              enterDelay={700}
              placement="bottom-start"
              style={{ fontSize: "20px" }}
            >
              <div>
                <TextTheme
                  message={this.props.comment}
                  className="text_med_grey text_small"
                />
              </div>
            </DateTooltip>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default NewsfeedComment;
